import { render, staticRenderFns } from "./EditLeaveTypeModal.vue?vue&type=template&id=1717dd94&"
import script from "./EditLeaveTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditLeaveTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports